import { Collapse } from 'bootstrap';

const toggle = document.querySelectorAll('[data-collapse]');

toggle.forEach(function (element) {
    const target = element.dataset.collapse;


    element.addEventListener("click", (e) => {
        const collapse = document.getElementById(target);

        if (element.checked == true) {
            Collapse.getOrCreateInstance(collapse).show();
        } else if (element.checked !== true) {
            Collapse.getOrCreateInstance(collapse).hide();
        }
    })

})